import { useUserPreferences } from '../../../../shared/user-preferences/hooks/useUserPreferences';
import { getPreferenceScope } from '../../../../shared/user-preferences/utils/preferences';
import { useFilterContext } from '../../filters/contexts/FilterProvider';
import { useEffectiveFilters } from '../../filters/hooks/useEffectiveFilters';
import type { Filter, PrimaryFilterId } from '../../filters/types/filters';
import { useTabContentConfig } from '../PageConfigProvider/PageConfigProvider';

export type CompositionV4Filters = {
  filters: Filter[];
  isLoading: boolean;
};

export const useCompositionV4Filters = ({
  primaryDimension,
}: {
  primaryDimension: PrimaryFilterId;
}): CompositionV4Filters => {
  const { isTaxonomyResolved } = useFilterContext();
  const { revelioPageId } = useTabContentConfig();
  const filters = useEffectiveFilters({ viewGranularity: 'month' });
  const { isInitialLoading: isPreferencesInitialLoading } = useUserPreferences(
    getPreferenceScope({
      pageId: revelioPageId,
      primaryFilterId: primaryDimension,
    })
  );

  const isLoading = !isTaxonomyResolved || isPreferencesInitialLoading;

  return { filters, isLoading };
};
